import React from 'react';
import { PrimaryButton, Modal } from 'wf-react-component-library';

import './ItemDetailsModal.scss';

const ErrorModal = (props) => (
  <Modal show={props.showErrorModal} width="75%">
    <div className="flex-container-row item-details-container show">
      <div className="flex-container-row row-details">
        {props.errorMessages}
      </div>

      <div className="flex-container-row buttons">
        <PrimaryButton onClick={props.closeModal} name="Close" />
      </div>
    </div>
  </Modal>
);

export default ErrorModal;
